<template>
    <div class="contest responsive-height">
        <v-container class="custom-container">
            <v-row dense>
                <v-col cols="12">
                    <TermsAndConditionTabs></TermsAndConditionTabs>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import TermsAndConditionTabs from '@/components/TermsAndCondition/TermsAndConditionTabs.vue';
export default {
    components: { TermsAndConditionTabs },
}
</script>
